import { generalRouter } from 'Components'
import { ListView as UserList, DetailView as UserDetail } from './Users'
import { ListView as SpaceList, DetailView as SpaceDetail } from './Spaces'
import { ListView as RoleList, DetailView as RoleDetail } from './Roles'
import { ListView as FunctionList, DetailView as FunctionDetail } from './Functions'
import { ListView as DomainsList, DetailView as DomainDetail } from './Domains'

routes = [{
  component: DomainsList
  exact: true
  path: '/acl/domains'
  isPublic: false
}, {
  component: DomainDetail
  exact: true
  path: '/acl/domains/:id'
  isPublic: false
}, {
  component: SpaceList
  exact: true
  path: '/acl/spaces'
  isPublic: false
}, {
  component: SpaceDetail
  exact: true
  path: '/acl/spaces/:id'
  isPublic: false
}, {
  component: SpaceDetail
  exact: true
  path: '/acl/spaces/:id/:action'
  isPublic: false
}, {
  component: UserList
  exact: true
  path: '/acl/users'
  isPublic: false
}, {
  component: UserDetail
  path: '/acl/users/:id'
  isPublic: false
}, {
  component: RoleList
  path: '/acl/groups'
  exact: true
  isPublic: false
}, {
  component: RoleDetail
  path: '/acl/groups/:id'
  isPublic: false
}, {
  component: FunctionList
  path: '/acl/permissions'
  exact: true
  isPublic: false
}, {
  component: FunctionDetail
  path: '/acl/permissions/:id'
  isPublic: false
}]

export default generalRouter(routes)

